<ng-container *ngIf="selectedCompany; else selectCompanyHint">
  <section class="pops-section card"
           (mouseenter)="handlePanelMouseEnter()"
           (mouseleave)="handlePanelMouseLeave()">
    <nav class="pop-view-tabs" *ngIf="companyPops.length > 0">
      <button type="button" (click)="onChangeViewMode('list')" [class.active]="popViewMode === 'list'">
        <span>List view</span>
        <span [ngClass]="chevronClass('list')"></span>
      </button>
      <button type="button" (click)="onChangeViewMode('map')" [class.active]="popViewMode === 'map'"
              [disabled]="mappablePops.length === 0">
        <span>Map view</span>
        <span [ngClass]="chevronClass('map')"></span>
        <span class="tab-hint" *ngIf="mappablePops.length === 0">No coordinates</span>
      </button>
    </nav>

    <div class="loading" *ngIf="loadingPops">
      <i class="pi pi-spin pi-spinner"></i>
    </div>

    <div class="alert alert-info" *ngIf="!loadingPops && companyPops.length === 0">
      No PoP with active service found for this customer.
    </div>

    <div class="pop-grid" *ngIf="!loadingPops && companyPops.length > 0 && popViewMode === 'list'"
         [ngClass]="{'pop-grid--collapsed': collapsedListView}">
      <div class="pop-card card" *ngFor="let pop of companyPops"
           [class.selected]="pop.id === selectedPopId"
           (click)="onSelectPop(pop, 'list')"
           title="See PoP details">
        <div class="pop-card-header">
          <span class="pop-badge">{{ pop.displayId || 'N/A' }}</span>
          <h4>{{ pop.name }}</h4>
        </div>
        <div class="pop-location">{{ pop.city || pop.region }} {{ pop.country }}</div>
        <ng-container *ngIf="getPopCrossConnectLinks(pop) as links">
          <div class="pop-xco-list"
               [class.pop-xco-list--collapsed]="links.length > 8 && !isPopXcoExpanded(pop.id)">
            <span class="label">
              <ng-container *ngIf="links.length > 0">
                {{ links.length }} XCO{{ links.length === 1 ? '' : 's' }}:
              </ng-container>
              <ng-container *ngIf="links.length === 0">
                XCOs:
              </ng-container>
            </span>
            <span *ngIf="links.length === 0">N/A</span>
            <span *ngFor="let link of links; let isLast=last" class="xco-label">
              <span>{{ link.label }}</span>{{ isLast ? '' : ', ' }}
            </span>
          </div>
          <button class="pop-xco-toggle" type="button" *ngIf="links.length > 8"
                  (click)="togglePopXcoExpansion(pop, $event)">
            {{ isPopXcoExpanded(pop.id) ? 'See less' : 'See more' }}
          </button>
        </ng-container>
        <div class="service-chips">
          <span class="service-chip" *ngFor="let service of pop.services" [ngClass]="getServiceChipClass(service)">
            {{ serviceLabel(service) }}
          </span>
        </div>
      </div>
    </div>

    <div class="map-view-panel" *ngIf="mappablePops.length > 0 && popViewMode === 'map'"
         [ngClass]="{'map-view-panel--collapsed': collapsedMapView}">
      <app-service-delivery-location-map
        [pops]="mappablePops"
        [selectedPopId]="selectedPopId"
        [loading]="loadingPops"
        (selectPop)="onSelectPop($event, 'map')">
      </app-service-delivery-location-map>
      <div class="map-legend">
        <div class="legend-item">
          <span class="legend-swatch legend-swatch--market"></span>
          <span>MD only</span>
        </div>
        <div class="legend-item">
          <span class="legend-swatch legend-swatch--bandwidth"></span>
          <span>BW only</span>
        </div>
        <div class="legend-item">
          <span class="legend-swatch legend-swatch--mixed"></span>
          <span>Both MD &amp; BW</span>
        </div>
      </div>
    </div>
  </section>
</ng-container>

<ng-template #selectCompanyHint>
  <div class="alert alert-info">
    Select a company to display its service delivery locations.
  </div>
</ng-template>
